import React, { useEffect, useState } from 'react'
import ViewImages from './ViewImages/ViewImages';

const ViewGalleryPhoto = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
        const stored = sessionStorage.getItem("isSidebarOpen");
        return stored !== null ? JSON.parse(stored) : true;
    });

    useEffect(() => {
        const interval = setInterval(() => {
            const stored = sessionStorage.getItem("isSidebarOpen");
            const parsed = stored !== null ? JSON.parse(stored) : true;

            if (parsed !== isSidebarOpen) {
                setIsSidebarOpen(parsed);
            }
        }, 10);

        return () => clearInterval(interval);
    }, [isSidebarOpen]);
    return (
        <div
            className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
            style={{ marginTop: "100px" }}
        >
            <div className="page-inner-wrapper">

                <h2 className="mb-4"> View Gallery</h2>
                <div>
                    <ViewImages />
                </div>
            </div>
        </div>

    )
}

export default ViewGalleryPhoto